import { UIIcon } from "@dropbox/dig-icons";
import { ClockLine, Twinkle2Line } from "@dropbox/dig-icons/assets";
import { BaseResultRow } from "./BaseResultRow";

export const TitleAndIconResultRow = (props: {
  iconType: "twinkle" | "clock";
  title: string;
  currentQuery: string;
}) => {
  const { iconType, title, currentQuery } = props;

  let icon;
  switch (iconType) {
    // Note: we need to manually override color to support inverted background in dark mode
    case "twinkle":
      icon = (
        <UIIcon src={Twinkle2Line} color={"var(--dig-color__text__base)"} />
      );
      break;
    case "clock":
      icon = <UIIcon src={ClockLine} color={"var(--dig-color__text__base)"} />;
      break;
    default:
      icon = (
        <UIIcon src={Twinkle2Line} color={"var(--dig-color__text__base)"} />
      );
      break;
  }

  return (
    <BaseResultRow
      icon={icon}
      title={title}
      highlightWords={
        currentQuery ? currentQuery.split(" ").map((word) => word.trim()) : []
      }
    />
  );
};
